import React from "react";
import { useDroppable } from "@dnd-kit/core";
import DraggableItem from "./Item";
import "./index.scss";
import { ClippedContent } from "dyl-components/atoms/ClippedContent";

export default function Container({
  id,
  title,
  items = [],
  isFirstStage,
  isLastStage
}) {
  const { setNodeRef, isOver, active } = useDroppable({ id });

  const showPlaceholder = !items?.some((item) => item.id === active?.id) && isOver

  return (
    <div
      ref={setNodeRef}
      className="Pipeline_Reports__Container"
    >
      <div className="Pipeline_Reports__Container__Header">
        <div className={`Header_Top ${isFirstStage ? "Header_Top--leftBorder" : ""} ${isLastStage ? "Header_Top--rightBorder" : ""}`}>
          <span className="Pipeline_Reports__Container__Header__Title">
            <ClippedContent popupContent={title}>
              {title}
            </ClippedContent>
          </span>
          <div className="Pipeline_Reports__Container__Header__Badge">{items.length}</div>
        </div>
      </div>

      <div className="Pipeline_Reports__Container__Body">
        {items.map((item) => (
          <DraggableItem
            key={item.id}
            item={item}
          />
        ))}

        {showPlaceholder && (
          <div
            className="Pipeline_Reports__Container__Placeholder"
          />
        )}
      </div>
    </div>
  );
}
